import React, { useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Textarea } from '../ui/textarea';
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from '../ui/dialog';
import { API_URL, errMsg, fmtH, hoursBetween } from './shared';
import { PlacePicker } from './PlacePicker';

export const CorrectDialog = ({ entry, onClose, onDone }) => {
  const [f, setF] = useState({ start: entry.start, end: entry.end, break_min: entry.break_min || 0 });
  const [place, setPlace] = useState({ project_id: entry.project_id, category: entry.category });
  const [saving, setSaving] = useState(false);
  const hours = hoursBetween(f.start, f.end, f.break_min);
  const save = async () => {
    setSaving(true);
    try {
      await axios.post(`${API_URL}/godziny/entries/${entry.id}/approve`, { ...f, break_min: Number(f.break_min) || 0, ...place });
      toast.success('Poprawiono i zatwierdzono');
      onDone();
      onClose();
    } catch (e) { toast.error(errMsg(e, 'Błąd')); } finally { setSaving(false); }
  };
  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="bg-[var(--crm-bg-dialog)] border-[var(--crm-border)]" data-testid="correct-dialog">
        <DialogHeader><DialogTitle className="text-[var(--crm-text-primary)]">Popraw i zatwierdź</DialogTitle></DialogHeader>
        {entry.place_type === 'unlisted' && (
          <p className="text-sm text-amber-600">Pracownik wpisał: „{entry.unlisted_client}” {entry.unlisted_address || ''}. Przypisz zlecenie albo kategorię.</p>
        )}
        <div className="grid grid-cols-3 gap-3">
          <div><Label>Od</Label><Input type="time" value={f.start} onChange={(e) => setF({ ...f, start: e.target.value })} data-testid="correct-start-input" /></div>
          <div><Label>Do</Label><Input type="time" value={f.end} onChange={(e) => setF({ ...f, end: e.target.value })} data-testid="correct-end-input" /></div>
          <div><Label>Przerwa</Label><Input type="number" min="0" value={f.break_min} onChange={(e) => setF({ ...f, break_min: e.target.value })} data-testid="correct-break-input" /></div>
        </div>
        <PlacePicker value={place} onChange={setPlace} testid="correct-place" />
        <p className="text-sm text-[var(--crm-text-secondary)]">Godziny: <strong>{hours ? fmtH(hours) : '—'}</strong></p>
        <DialogFooter>
          <Button variant="outline" onClick={onClose}>Anuluj</Button>
          <Button onClick={save} disabled={saving || !hours || (!place.project_id && !place.category)} className="bg-[#FF6B35] hover:bg-[#e55a2b] text-white"
            data-testid="correct-save-btn">Zatwierdź</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export const RejectDialog = ({ entry, onClose, onDone }) => {
  const [reason, setReason] = useState('');
  const save = async () => {
    try {
      await axios.post(`${API_URL}/godziny/entries/${entry.id}/reject`, { reason });
      toast.success('Wpis odrzucony');
      onDone();
      onClose();
    } catch (e) { toast.error(errMsg(e, 'Błąd')); }
  };
  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="bg-[var(--crm-bg-dialog)] border-[var(--crm-border)]" data-testid="reject-dialog">
        <DialogHeader><DialogTitle className="text-[var(--crm-text-primary)]">Odrzuć wpis</DialogTitle></DialogHeader>
        <Label>Powód (zobaczy go pracownik)</Label>
        <Textarea value={reason} onChange={(e) => setReason(e.target.value)} rows={3} data-testid="reject-reason-input" />
        <DialogFooter>
          <Button variant="outline" onClick={onClose}>Anuluj</Button>
          <Button onClick={save} disabled={!reason.trim()} className="bg-red-600 hover:bg-red-700 text-white" data-testid="reject-save-btn">Odrzuć</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
